module.exports = require("./zh.d.ts");